import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { map } from "rxjs";
import { FirebaseService } from "../services/firebase.service";
import { AuthenticationService } from '../../pages/services/authentication.service';
import { SessionService } from '../../core/session/session.service';
import { ROUTES_APP } from '../../app.routes';

export const UserIsLoggedIn: CanActivateFn = () => {
  const urlLogin = inject(Router).createUrlTree(['/login'])
  return inject(FirebaseService).isAuthenticatedUser()
    .pipe(map(isLogin => isLogin || urlLogin))
}

export const UserIsNotLoggedIn: CanActivateFn = () => {
  const urlNav = inject(Router).createUrlTree([`/home`])
  return inject(FirebaseService).isAuthenticatedUser()
    .pipe(map(isLogin => isLogin ? urlNav : true))
}

export const authGuard: CanActivateFn = () => {
  const session = inject(SessionService);
  const router = inject(Router);

  if (!session.isAuthenticated()) {
    router.navigate([ROUTES_APP.LOGIN], { replaceUrl: true });
    return false;
  }

  return true;
};

export const loginRedirectGuard: CanActivateFn = () => {
  const session = inject(SessionService);
  const router = inject(Router);

  if (session.isAuthenticated()) {
    router.navigate([ROUTES_APP.MEDICAL_CENTERS], { replaceUrl: true });
    return false;
  }

  return true;
};

export const medicalCenterGuard: CanActivateFn = () => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);

  if (!authService.isSelectedMedicalCenter()) {
    router.navigate([ROUTES_APP.MEDICAL_CENTERS], { replaceUrl: true });
    return false;
  }

  return true;
};

